// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Text = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Text.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("./DOM__Element.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("./DomElementIdentifierGenerator.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("./DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "parentElement",
                Curry._1(encoder_domElementRepresentation, v.parentElement)
              ],
              [
                "textNodeIndex",
                Decco.intToJson(v.textNodeIndex)
              ],
              [
                "text",
                Decco.stringToJson(v.text)
              ]
            ]);
}

function t_decode(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var parentElement = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentElement"), null));
  if (parentElement.TAG === /* Ok */0) {
    var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
    if (textNodeIndex.TAG === /* Ok */0) {
      var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
      if (text.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  parentElement: parentElement._0,
                  textNodeIndex: textNodeIndex._0,
                  text: text._0
                }
              };
      }
      var e = text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = textNodeIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".textNodeIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = parentElement._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".parentElement" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var NonEmptySegment = {
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(encoder_domElementRepresentation, v) {
  if (v.TAG === /* NonEmptySegment */0) {
    return [
            "NonEmptySegment",
            t_encode(encoder_domElementRepresentation, v._0)
          ];
  } else {
    return [
            "EmptySegment",
            Curry._1(encoder_domElementRepresentation, v._0)
          ];
  }
}

function t_decode$1(decoder_domElementRepresentation, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EmptySegment" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* EmptySegment */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NonEmptySegment" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NonEmptySegment */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function textSegmentsFromElement(element) {
  var childNodes = Array.prototype.slice.call(element.childNodes);
  if (childNodes.length === 0) {
    return {
            hd: {
              TAG: /* EmptySegment */1,
              _0: element
            },
            tl: /* [] */0
          };
  } else {
    return Belt_Array.reduceWithIndex(childNodes, /* [] */0, (function (previousTextSegments, node, index) {
                  var match = Webapi__Dom__Node.nodeType(node);
                  if (match >= 3) {
                    return previousTextSegments;
                  }
                  switch (match) {
                    case /* Element */0 :
                        var arg = Webapi__Dom__Element.ofNode(node);
                        var textSegments = textSegmentsFromElement((function (param) {
                                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                })("Expected to get Element from Node when nodeType = Element at TextContents.fromContentEditableHost"));
                        return List.append(previousTextSegments, textSegments);
                    case /* Attribute */1 :
                        return previousTextSegments;
                    case /* Text */2 :
                        var arg$1 = Webapi__Dom__Text.ofNode(node);
                        var text = (function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                            })("Expected to get Text from Node when nodeType = Text at TextContents.fromContentEditableHost").data;
                        return List.append(previousTextSegments, {
                                    hd: {
                                      TAG: /* NonEmptySegment */0,
                                      _0: {
                                        parentElement: element,
                                        textNodeIndex: index,
                                        text: text
                                      }
                                    },
                                    tl: /* [] */0
                                  });
                    
                  }
                }));
  }
}

function mapDomElementRepresentation(f, segment) {
  if (segment.TAG !== /* NonEmptySegment */0) {
    return {
            TAG: /* EmptySegment */1,
            _0: Curry._1(f, segment._0)
          };
  }
  var inner = segment._0;
  return {
          TAG: /* NonEmptySegment */0,
          _0: {
            parentElement: Curry._1(f, inner.parentElement),
            textNodeIndex: inner.textNodeIndex,
            text: inner.text
          }
        };
}

function elementGet(segment) {
  if (segment.TAG === /* NonEmptySegment */0) {
    return segment._0.parentElement;
  } else {
    return segment._0;
  }
}

function textGet(segment) {
  if (segment.TAG === /* NonEmptySegment */0) {
    return segment._0.text;
  } else {
    return "";
  }
}

function findFirstEmptySegmentContainingBreakBeforeNonEmptySegment(_reversedSegments) {
  while(true) {
    var reversedSegments = _reversedSegments;
    if (!reversedSegments) {
      return ;
    }
    var segment = reversedSegments.hd;
    if (segment.TAG === /* NonEmptySegment */0) {
      return ;
    }
    if (segment._0.tagName === "BR") {
      return segment;
    }
    _reversedSegments = reversedSegments.tl;
    continue ;
  };
}

function isPrecededByAnyEmptySegmentContainingBreak(index, textSegments) {
  var precedingSegments = Belt_List.take(textSegments, index);
  if (precedingSegments !== undefined) {
    return findFirstEmptySegmentContainingBreakBeforeNonEmptySegment(List.rev(precedingSegments)) !== undefined;
  } else {
    return false;
  }
}

function toMaybeRangeContainerAndOffsetForCursor(positionInside, textSegment) {
  if (textSegment.TAG === /* NonEmptySegment */0) {
    var match = textSegment._0;
    return [
            Caml_option.nullable_to_opt(match.parentElement.childNodes.item(match.textNodeIndex)),
            typeof positionInside === "number" ? (
                positionInside !== 0 ? match.text.length : 0
              ) : positionInside._0
          ];
  }
  var element = textSegment._0;
  var match$1 = element.tagName;
  if (match$1 !== "BR") {
    return [
            Caml_option.some(element),
            0
          ];
  }
  var arg = element.parentElement;
  var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
  var parentElement = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected parent element for <br>");
  var childNodesOfParent = parentElement.childNodes;
  var maybeIndex = Belt_Array.getIndexBy(Array.prototype.slice.call(childNodesOfParent), (function (node) {
          return node === element;
        }));
  var offset = maybeIndex !== undefined ? maybeIndex : childNodesOfParent.length;
  return [
          Caml_option.some(parentElement),
          offset
        ];
}

var TextSegment = {
  NonEmptySegment: NonEmptySegment,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  textSegmentsFromElement: textSegmentsFromElement,
  mapDomElementRepresentation: mapDomElementRepresentation,
  elementGet: elementGet,
  textGet: textGet,
  isPrecededByAnyEmptySegmentContainingBreak: isPrecededByAnyEmptySegmentContainingBreak,
  toMaybeRangeContainerAndOffsetForCursor: toMaybeRangeContainerAndOffsetForCursor
};

function textContent_encode(encoder_domElementRepresentation, v) {
  if (v.TAG === /* TextSegment */0) {
    return [
            "TextSegment",
            t_encode$1(encoder_domElementRepresentation, v._0)
          ];
  } else {
    return [
            "TextSegmentAtParagraphBoundary",
            t_encode$1(encoder_domElementRepresentation, v._0)
          ];
  }
}

function textContent_decode(decoder_domElementRepresentation, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "TextSegment" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextSegment */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TextSegmentAtParagraphBoundary" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextSegmentAtParagraphBoundary */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function textGet$1(textContent) {
  if (textContent.TAG === /* TextSegment */0) {
    var match = textContent._0;
    if (match.TAG === /* NonEmptySegment */0) {
      return match._0.text;
    } else {
      return "";
    }
  }
  var match$1 = textContent._0;
  if (match$1.TAG === /* NonEmptySegment */0) {
    return match$1._0.text;
  } else {
    return "";
  }
}

function t_encode$2(encoder_domElementRepresentation, v) {
  return Decco.listToJson((function (param) {
                return textContent_encode(encoder_domElementRepresentation, param);
              }), v);
}

function t_decode$2(decoder_domElementRepresentation, v) {
  return Decco.listFromJson((function (param) {
                return textContent_decode(decoder_domElementRepresentation, param);
              }), v);
}

function fromElement(makeDomElementRepresentation, element) {
  var textSegments = textSegmentsFromElement(element);
  return Belt_List.reduceWithIndex(textSegments, /* [] */0, (function (textContents, currTextSegment, index) {
                var match = Belt_List.get(textSegments, index - 1 | 0);
                var textContent = match !== undefined && (StringUtils$SmartcutsMacros.containsNewLine(DOM__Element$SmartcutsMacros.commonAncestor(elementGet(currTextSegment), elementGet(match)).innerText) || currTextSegment.TAG === /* NonEmptySegment */0 && isPrecededByAnyEmptySegmentContainingBreak(index, textSegments)) ? ({
                      TAG: /* TextSegmentAtParagraphBoundary */1,
                      _0: mapDomElementRepresentation(makeDomElementRepresentation, currTextSegment)
                    }) : ({
                      TAG: /* TextSegment */0,
                      _0: mapDomElementRepresentation(makeDomElementRepresentation, currTextSegment)
                    });
                return Belt_List.concat(textContents, {
                            hd: textContent,
                            tl: /* [] */0
                          });
              }));
}

function isAtParagraphBoundary(index, textContents) {
  var match = Belt_List.get(textContents, index);
  if (match !== undefined && match.TAG !== /* TextSegment */0) {
    return true;
  } else {
    return false;
  }
}

function fullText(textContents) {
  return Belt_List.reduce(textContents, "", (function (fullText, textContent) {
                if (textContent.TAG === /* TextSegment */0) {
                  return fullText + textGet(textContent._0);
                } else {
                  return fullText + ("\n" + textGet(textContent._0));
                }
              }));
}

function offsetFormBeginningOfParagraph(index, paragraphStartsAtIndex, offset, textContens) {
  var func = function (param, param$1) {
    return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(offset, param, param$1);
  };
  var arg = Curry._2(func, (function (offset, textContent, index$p) {
          if (index === index$p) {
            return [
                    offset,
                    offset
                  ];
          }
          if (index$p >= paragraphStartsAtIndex) {
            return [
                    offset,
                    undefined
                  ];
          }
          var text = textGet$1(textContent);
          return [
                  offset + text.length | 0,
                  undefined
                ];
        }), textContens);
  var param = "Expected to find offsetFromBegining()";
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function offsetFormBeginning(index, offset, textContens) {
  var func = function (param, param$1) {
    return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(offset, param, param$1);
  };
  var arg = Curry._2(func, (function (offset, textContent, index$p) {
          if (index === index$p) {
            return [
                    offset,
                    offset
                  ];
          }
          var text = textGet$1(textContent);
          return [
                  offset + text.length | 0,
                  undefined
                ];
        }), textContens);
  var param = "Expected to find offsetFromBegining()";
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function locateNthParagraph(nthParagraph, textContents) {
  var match = Belt_List.reduceWithIndex(textContents, [
        nthParagraph,
        0,
        0
      ], (function (state, textContent, index) {
          var startIndex = state[1];
          var nParagraphRemaining = state[0];
          if (textContent.TAG === /* TextSegment */0) {
            return state;
          } else if (nParagraphRemaining === 0) {
            return [
                    nParagraphRemaining,
                    startIndex,
                    index - 1 | 0
                  ];
          } else {
            return [
                    nParagraphRemaining - 1 | 0,
                    nParagraphRemaining === 1 ? index : startIndex,
                    state[2]
                  ];
          }
        }));
  var endIndex = match[2];
  var startIndex = match[1];
  var length = List.length(textContents);
  if (length !== 0) {
    if (endIndex === 0) {
      return [
              startIndex,
              length - 1 | 0
            ];
    } else {
      return [
              startIndex,
              endIndex
            ];
    }
  }
  
}

var Generic = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromElement: fromElement,
  isAtParagraphBoundary: isAtParagraphBoundary,
  fullText: fullText,
  offsetFormBeginningOfParagraph: offsetFormBeginningOfParagraph,
  offsetFormBeginning: offsetFormBeginning,
  locateNthParagraph: locateNthParagraph
};

function t_encode$3(v) {
  return Decco.listToJson((function (param) {
                return textContent_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, param);
              }), v);
}

function t_decode$3(v) {
  return Decco.listFromJson((function (param) {
                return textContent_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, param);
              }), v);
}

function fromElement$1(domElementIdentifierGenerator, element) {
  return fromElement((function (element) {
                var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
                return {
                        domElementIdentifier: domElementIdentifier,
                        selector: Selector$SmartcutsMacros.forDomElement(element)
                      };
              }), element);
}

function updateSelector(f, recording) {
  return Belt_List.map(recording, (function (textContent) {
                if (textContent.TAG === /* TextSegment */0) {
                  var domElementRepresentation = textContent._0;
                  if (domElementRepresentation.TAG === /* NonEmptySegment */0) {
                    var match = domElementRepresentation._0;
                    var domElementRepresentation$1 = match.parentElement;
                    return {
                            TAG: /* TextSegment */0,
                            _0: {
                              TAG: /* NonEmptySegment */0,
                              _0: {
                                parentElement: {
                                  domElementIdentifier: domElementRepresentation$1.domElementIdentifier,
                                  selector: Curry._1(f, domElementRepresentation$1.selector)
                                },
                                textNodeIndex: match.textNodeIndex,
                                text: match.text
                              }
                            }
                          };
                  }
                  var domElementRepresentation$2 = domElementRepresentation._0;
                  return {
                          TAG: /* TextSegment */0,
                          _0: {
                            TAG: /* EmptySegment */1,
                            _0: {
                              domElementIdentifier: domElementRepresentation$2.domElementIdentifier,
                              selector: Curry._1(f, domElementRepresentation$2.selector)
                            }
                          }
                        };
                }
                var textSegment = textContent._0;
                if (textSegment.TAG === /* NonEmptySegment */0) {
                  var textSegment$1 = textSegment._0;
                  var domElementRepresentation$3 = textSegment$1.parentElement;
                  return {
                          TAG: /* TextSegmentAtParagraphBoundary */1,
                          _0: {
                            TAG: /* NonEmptySegment */0,
                            _0: {
                              parentElement: {
                                domElementIdentifier: domElementRepresentation$3.domElementIdentifier,
                                selector: Curry._1(f, domElementRepresentation$3.selector)
                              },
                              textNodeIndex: textSegment$1.textNodeIndex,
                              text: textSegment$1.text
                            }
                          }
                        };
                }
                var domElementRepresentation$4 = textSegment._0;
                return {
                        TAG: /* TextSegmentAtParagraphBoundary */1,
                        _0: {
                          TAG: /* EmptySegment */1,
                          _0: {
                            domElementIdentifier: domElementRepresentation$4.domElementIdentifier,
                            selector: Curry._1(f, domElementRepresentation$4.selector)
                          }
                        }
                      };
              }));
}

function search(domElementIdentifier, textNodeIndex, textContents) {
  var param_textContent = List.hd(textContents);
  var param = {
    nthParagraph: 0,
    index: 0,
    textContent: param_textContent,
    currentParagraphStartsAtIndex: 0
  };
  var param$1 = function (searchResult, textContent, index) {
    var nthParagraph = searchResult.nthParagraph;
    if (textContent.TAG === /* TextSegment */0) {
      var match = textContent._0;
      if (match.TAG === /* NonEmptySegment */0) {
        var match$1 = match._0;
        if (!(match$1.parentElement.domElementIdentifier === domElementIdentifier && match$1.textNodeIndex === textNodeIndex)) {
          return [
                  searchResult,
                  undefined
                ];
        }
        var found_currentParagraphStartsAtIndex = searchResult.currentParagraphStartsAtIndex;
        var found = {
          nthParagraph: nthParagraph,
          index: index,
          textContent: textContent,
          currentParagraphStartsAtIndex: found_currentParagraphStartsAtIndex
        };
        return [
                found,
                found
              ];
      }
      if (match._0.domElementIdentifier !== domElementIdentifier) {
        return [
                searchResult,
                undefined
              ];
      }
      var found_currentParagraphStartsAtIndex$1 = searchResult.currentParagraphStartsAtIndex;
      var found$1 = {
        nthParagraph: nthParagraph,
        index: index,
        textContent: textContent,
        currentParagraphStartsAtIndex: found_currentParagraphStartsAtIndex$1
      };
      return [
              found$1,
              found$1
            ];
    }
    var match$2 = textContent._0;
    if (match$2.TAG === /* NonEmptySegment */0) {
      var match$3 = match$2._0;
      if (match$3.parentElement.domElementIdentifier === domElementIdentifier && match$3.textNodeIndex === 0) {
        var found_nthParagraph = nthParagraph + 1 | 0;
        var found$2 = {
          nthParagraph: found_nthParagraph,
          index: index,
          textContent: textContent,
          currentParagraphStartsAtIndex: index
        };
        return [
                found$2,
                found$2
              ];
      }
      
    } else if (match$2._0.domElementIdentifier === domElementIdentifier) {
      var found_nthParagraph$1 = nthParagraph + 1 | 0;
      var found$3 = {
        nthParagraph: found_nthParagraph$1,
        index: index,
        textContent: textContent,
        currentParagraphStartsAtIndex: index
      };
      return [
              found$3,
              found$3
            ];
    }
    return [
            {
              nthParagraph: nthParagraph + 1 | 0,
              index: searchResult.index,
              textContent: searchResult.textContent,
              currentParagraphStartsAtIndex: index
            },
            undefined
          ];
  };
  return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(param, param$1, textContents);
}

function searchNode(domElementIdentifierGenerator, _node, textContents) {
  while(true) {
    var node = _node;
    var match = Webapi__Dom__Node.nodeType(node);
    if (match >= 3) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected Text or Element node when TextContents.searchNode()");
    }
    switch (match) {
      case /* Element */0 :
          var childNodes = Array.prototype.slice.call(node.childNodes);
          var firstTextChild = Util$SmartcutsMacros.shortcut2(childNodes, (function (node) {
                  var match = Webapi__Dom__Node.nodeType(node);
                  if (match !== 2) {
                    return ;
                  } else {
                    return Caml_option.some(node);
                  }
                }));
          if (firstTextChild === undefined) {
            return ArrayUtils$SmartcutsMacros.shortcut((function (childNode) {
                          return searchNode(domElementIdentifierGenerator, childNode, textContents);
                        }), childNodes);
          }
          _node = Caml_option.valFromOption(firstTextChild);
          continue ;
      case /* Attribute */1 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Expected Text or Element node when TextContents.searchNode()");
      case /* Text */2 :
          var arg = node.parentElement;
          var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
          var element = (function(arg$1){
            return function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }
            }(arg$1))("Expect Text node has Element parent node");
          var arg$2 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(element.childNodes), (function(node){
              return function (sibling, index) {
                if (Caml_obj.caml_equal(sibling, node)) {
                  return index;
                }
                
              }
              }(node)));
          var textNodeIndex = (function(arg$2){
            return function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
            }
            }(arg$2))("Expected to find index of Text node in its containing Element");
          var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
          return search(domElementIdentifier, textNodeIndex, textContents);
      
    }
  };
}

var ForRecordingAndAuthoring = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromElement: fromElement$1,
  updateSelector: updateSelector,
  search: search,
  searchNode: searchNode
};

function fromElement$2(param) {
  return fromElement((function (element) {
                return element;
              }), param);
}

function getElementAtIndex(index, textContents) {
  var match = Belt_List.get(textContents, index);
  if (match === undefined) {
    return ;
  }
  if (match.TAG === /* TextSegment */0) {
    var element = match._0;
    if (element.TAG === /* NonEmptySegment */0) {
      return Caml_option.some(element._0.parentElement);
    } else {
      return Caml_option.some(element._0);
    }
  }
  var element$1 = match._0;
  if (element$1.TAG === /* NonEmptySegment */0) {
    return Caml_option.some(element$1._0.parentElement);
  } else {
    return Caml_option.some(element$1._0);
  }
}

var ForPlayback = {
  fromElement: fromElement$2,
  getElementAtIndex: getElementAtIndex
};

exports.TextSegment = TextSegment;
exports.textContent_encode = textContent_encode;
exports.textContent_decode = textContent_decode;
exports.textGet = textGet$1;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring;
exports.ForPlayback = ForPlayback;
/* Webapi__Dom__Node Not a pure module */
